export default __webpack_public_path__ + "media/images/footer/hipercard-178c533fc4e9723db482a392697e6ed1.svg";